export const funnelSteps = [
  {
    id: 'projectType',
    title: 'What are you looking to build?',
    options: [
      { label: 'Internal Business Application', icon: 'FiBriefcase' },
      { label: 'Customer-Facing Application', icon: 'FiSmartphone' },
      { label: 'Workflow / Automation', icon: 'FiGitBranch' },
      { label: 'Dashboard / Analytics', icon: 'FiPieChart' },
      { label: 'Marketplace / Platform', icon: 'FiGlobe' },
      { label: 'Something Else', icon: 'FiBox' }
    ]
  },
  {
    id: 'problem',
    title: 'What problem are you trying to solve?',
    options: [
      { label: 'Replace manual processes', icon: 'FiCpu' },
      { label: 'Improve customer experience', icon: 'FiHeart' },
      { label: 'Connect existing systems', icon: 'FiLink' },
      { label: 'Launch a new digital product', icon: 'FiStar' },
      { label: 'Reduce operational costs', icon: 'FiTrendingDown' },
      { label: 'Other', icon: 'FiEdit2' }
    ]
  },
  {
    id: 'users',
    title: 'Who will use it?',
    options: [
      { label: 'Under 25 users', icon: 'FiUser' },
      { label: '25–100 users', icon: 'FiUsers' },
      { label: '100–1,000 users', icon: 'FiMonitor' },
      { label: '1,000+ users', icon: 'FiGlobe' }
    ]
  },
  {
    id: 'timeline',
    title: 'How quickly do you need it?',
    options: [
      { label: 'ASAP', icon: 'FiAlertCircle' },
      { label: '1–3 months', icon: 'FiCalendar' },
      { label: '3–6 months', icon: 'FiCalendar' },
      { label: '6–12 months', icon: 'FiCalendar' },
      { label: 'Just exploring', icon: 'FiSearch' }
    ]
  },
  {
    id: 'integrations',
    title: 'Does it need to connect to existing systems?',
    options: [
      { label: 'No', icon: 'FiSquare' },
      { label: 'Yes', icon: 'FiLink' },
      { label: 'Not sure', icon: 'FiHelpCircle' }
    ]
  }
];